import { render, staticRenderFns } from "./ProcessExceptionEdit.vue?vue&type=template&id=4922aca8&scoped=true&"
import script from "./ProcessExceptionEdit.vue?vue&type=script&lang=js&"
export * from "./ProcessExceptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProcessExceptionEdit.vue?vue&type=style&index=0&id=4922aca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922aca8",
  null
  
)

export default component.exports